import cn from "classnames"
import { HTMLAttributes } from "react"
import { Div } from "trunx"

interface Props extends HTMLAttributes<HTMLDivElement> {
    className?: string
}

export function Box({ className, ...props }: Props) {
    return <Div bulma="box" {...props} className={cn("blm-box", className)} />
}
